<div class="info-teasers" *ngIf="!isLoading; else loadingInfoTeasers">
  <div
    class="info-teasers__item"
    *ngFor="let infoTeaser of infoTeasers | slice: 0 : 6; let i = index"
  >
    <div *ngIf="numbering" class="info-teasers__item__round-number">
      <h4>{{ i + 1 }}</h4>
    </div>
    <hdi-icon
      class="info-teasers__item__icon"
      [size]="Sizes.XXXLARGE"
      [color]="Colors.GREEN"
      [iconName]="infoTeaser.icon"
    ></hdi-icon>
    <p #text class="info-teasers__item__text" [innerHTML]="infoTeaser.text"></p>
  </div>
</div>

<!-- Loading Placeholder -->
<ng-template #loadingInfoTeasers>
  <div class="info-teasers">
    <div
      class="info-teasers__item info-teasers__item--loader"
      *ngFor="let infoTeaser of [].constructor(5)"
    >
      <ngx-skeleton-loader
        [theme]="{
          width: '100%',
          height: '100%',
          position: 'absolute',
          top: '0',
          left: '0',
          'margin-bottom': '0',
          'background-color': '#f9f9fa',
        }"
      ></ngx-skeleton-loader>
      <div class="info-teasers__item__round-number--loader">
        <ngx-skeleton-loader
          [theme]="{
            width: '100%',
            height: '100%',
            'margin-bottom': '0',
          }"
        ></ngx-skeleton-loader>
      </div>
      <div class="info-teasers__item__icon--loader">
        <ngx-skeleton-loader
          [theme]="{
            width: '100%',
            height: '100%',
            'margin-bottom': '0',
          }"
        ></ngx-skeleton-loader>
      </div>
      <div class="info-teasers__item__text--loader">
        <div class="first-row-loader">
          <ngx-skeleton-loader
            [theme]="{
              width: '100%',
              height: '100%',
              'margin-bottom': '0',
            }"
          ></ngx-skeleton-loader>
        </div>
        <div class="second-row-loader">
          <ngx-skeleton-loader
            [theme]="{
              width: '100%',
              height: '100%',
              'margin-bottom': '0',
            }"
          ></ngx-skeleton-loader>
        </div>
      </div>
    </div>
  </div>
</ng-template>
